import { computed, defineComponent } from "vue";

import "./link.less";

export default defineComponent({
  inheritAttrs: false,
  emits: ["click"],
  props: {
    text: { type: String, default: undefined },
    href: { type: String, default: undefined },
    disabled: { type: Boolean, default: false },
  },
  setup(props, { slots, emit }) {
    const href = computed(() => {
      return props.href ?? ["javascript", "void(0)"].join(":");
    });

    const onClick = (event: MouseEvent) => {
      if (props.disabled) return;
      if (props.href) return;
      emit("click", event);
    };

    return () => (
      <a
        class={["feiyu-web-link", { "feiyu-web-link--disabled": props.disabled }]}
        href={href.value}
        onClick={onClick}
      >
        {slots.default ? slots.default() : props.text}
      </a>
    );
  },
});
